import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import {
    ServiceCenterStatus,
    StorageType,
} from 'app/enums/label.enums'
import request from 'app/requests/ServiceCenter/ServiceCenter.requests'
import ServiceCenterForm from '../ServiceCenterForm'
import {
    StorageTableType,
} from '../serviceCenters.types'

const ServiceCenterCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    return (
        <ServiceCenterForm
            data={{
                storages: [
                    {
                        storageCapacity: 0,
                        storageType: StorageType.DRY,
                    },
                    {
                        storageCapacity: 0,
                        storageType: StorageType.C,
                    },
                ] as StorageTableType[],
                serviceCenterStatus: ServiceCenterStatus.PLANNED,
                enhancedSkyCenterScanning: true,
                orderSelectionDelay: 2,
            }}
            onSuccess={onSuccess}
            exists={false}
            requestParam={request.create()}
        />
    )
}

export default ServiceCenterCreate
